
export const headerData = {
    name: 'Kalash Thakur',
    title: "Hello! I am",
    desciption: "Observant and detail-oriented full-stack web developer specialized in MERN stack. Self-motivated and curious, with a keen interest in building user-centric products. Looking forward to getting immense opportunities to learn more technical stuff in the future. ",
    image: 'https://avatars.githubusercontent.com/u/83134042?v=4',
    imagebw: 'https://i.ibb.co/Cw2Xp90/abu-said-bw.jpg',
    resumePdf: 'https://drive.google.com/file/d/1Cglvi4hbLiQ1rl_TXbFWWQSHe7dkx0_4/view?usp=sharing'
}
